module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門5_3_2.ba2bbe21.png";